// @flow

export const SUMMARY = 'summary';
export const EXPLORER = 'explorer';

export type pageSettingsListT = 'summary' | 'explorer';
